const nav = [
  { path: '/home', text: 'My Solutions', 'icon': 'home' },
  { path: '/projects', text: 'My Dashboard', 'icon': 'th-list' },
  { path: '/company-details', text: 'My Company', 'icon': 'briefcase' },
  { path: '/partners', text: 'Third Parties', 'icon': 'handshake' }
  //{ path: '/contact-us', text: 'Contact Us', 'icon': 'comments' },
];

export default nav;
